import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Building2, Briefcase, Users, CheckSquare } from 'lucide-react';
import { useAuth } from '../utils/auth';
import { getPendingValidationsCount } from '../utils/mockData';
import { motion } from 'framer-motion';
export function MobileNav() {
  const {
    user
  } = useAuth();
  const pendingCount = getPendingValidationsCount();
  const getNavItems = () => {
    if (user?.role === 'technicien') {
      return [{
        icon: LayoutDashboard,
        label: 'Chantiers',
        path: '/'
      }];
    }
    if (user?.role === 'chef_equipe') {
      return [{
        icon: LayoutDashboard,
        label: 'Chantiers',
        path: '/'
      }, {
        icon: CheckSquare,
        label: 'Validations',
        path: '/validations',
        badge: pendingCount
      }];
    }
    if (user?.role === 'direction') {
      return [{
        icon: LayoutDashboard,
        label: 'Accueil',
        path: '/'
      }, {
        icon: Building2,
        label: 'Clients',
        path: '/clients'
      }, {
        icon: Briefcase,
        label: 'Chantiers',
        path: '/chantiers'
      }, {
        icon: Users,
        label: 'Équipe',
        path: '/team'
      }];
    }
    // Bureau and Admin
    return [{
      icon: LayoutDashboard,
      label: 'Accueil',
      path: '/'
    }, {
      icon: Building2,
      label: 'Clients',
      path: '/clients'
    }, {
      icon: Briefcase,
      label: 'Chantiers',
      path: '/chantiers'
    }, {
      icon: CheckSquare,
      label: 'Validations',
      path: '/validations',
      badge: pendingCount
    }, {
      icon: Users,
      label: 'Équipe',
      path: '/team'
    }];
  };
  const navItems = getNavItems();
  return <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 pb-safe shadow-strong" data-id="element-142">
      <div className="flex justify-around items-center h-16 px-2" data-id="element-143">
        {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
        isActive
      }) => `flex flex-col items-center justify-center flex-1 h-full space-y-1 relative rounded-lg transition-all duration-200 ${isActive ? 'text-[#1DBAB4]' : 'text-gray-500'}`} data-id="element-144">
            {({
          isActive
        }) => <>
                {isActive && <motion.div layoutId="mobile-nav-indicator" className="absolute top-0 left-1/2 -translate-x-1/2 w-12 h-1 bg-[#1DBAB4] rounded-full" transition={{
            type: 'spring',
            stiffness: 380,
            damping: 30
          }} data-id="element-145" />}
                <div className="relative" data-id="element-146">
                  <item.icon size={22} strokeWidth={isActive ? 2.5 : 2} className="transition-all duration-200" data-id="element-147" />
                  {item.badge && item.badge > 0 && <motion.span initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} className="absolute -top-1.5 -right-1.5 bg-[#E85D4A] text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center shadow-md" data-id="element-148">
                      {item.badge}
                    </motion.span>}
                </div>
                <span className={`text-[10px] font-medium transition-all duration-200 ${isActive ? 'font-semibold' : ''}`} data-id="element-149">
                  {item.label}
                </span>
              </>}
          </NavLink>)}
      </div>
    </nav>;
}